exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bulletin-notification[data-v-2b9580e4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 8px;\n  font-weight: bold;\n  text-align: center;\n  font-size: 20px;\n  background: #ff4d4f;\n  color: white;\n}\n.view-button[data-v-2b9580e4] {\n  margin-left: 12px;\n}\n", ""]);

// exports
